export const BUNDLE_NETPRICE_POST_REQUEST = 'BUNDLE_NETPRICE_POST_REQUEST';
export const BUNDLE_NETPRICE_POST_ERROR = 'ADDTOCART_POST_ERROR';
export const BUNDLE_NETPRICE_SUCCESS = 'BUNDLE_NETPRICE_SUCCESS';
